export default "__VITE_ASSET__C87JsDyg__"